import React from "react";
import type { IUploadCodeAndSourceSelectionStore } from "./UploadCodeAndSourceSelectionStore";
import { injectFromAppUpload } from "../../inject";
import { observer } from "mobx-react";
import { UploadCodeAndSourceSelectionValidatedComponent } from "./UploadCodeAndSourceSelectionValidatedComponent";
import { UploadCodeAndSourceSelectionInvalidatedComponent } from "./UploadCodeAndSourceSelectionInvalidatedComponent";

interface ICodeAndSourceSelectionComponent {
    uploadCodeAndSourceSelectionStore?: IUploadCodeAndSourceSelectionStore;
}

@injectFromAppUpload<ICodeAndSourceSelectionComponent>((stores) => ({
    uploadCodeAndSourceSelectionStore: stores.uploadCodeAndSourceSelectionStore,
}))

@observer
export class UploadCodeAndSourceSelectionComponent extends React.Component<ICodeAndSourceSelectionComponent> {
    render() {
        const { uploadCodeAndSourceSelectionStore } = this.props;
        const { uploadCodeAndSourceValid } = uploadCodeAndSourceSelectionStore!;

        return (
            <div id={"upload-code-and-source-selection-component"}>
                {!uploadCodeAndSourceValid ? <UploadCodeAndSourceSelectionInvalidatedComponent /> : <UploadCodeAndSourceSelectionValidatedComponent />}
            </div>
        );
    }
}
